import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  &.reset-btn {\n    height: 26px;\n    padding: 2px 0;\n    display: flex;\n    align-items: center;\n    border: none;\n    background-color: transparent;\n\n    i {\n      margin-right: 4px;\n    }\n\n    span {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n      color: ",
        ";\n      font-weight: bold;\n      transition: color 0.2s linear;\n\n      @media (hover: hover) {\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      padding: 0;\n      margin-left: 8px;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  &.current-btn {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    padding: 2px 12px;\n    line-height: 22px;\n    font-weight: 600;\n    border: none;\n    height: 26px;\n    background-color: ",
        ";\n    border-radius: 36px;\n    cursor: pointer;\n    font-size: 14px;\n    @media (max-width: 1200px) {\n    }\n    @media (max-width: 768px) {\n      /* padding: 2px 8px; */\n      height: 26px;\n      font-weight: 400;\n    }\n  }\n\n  &.category {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from "@/components/Books/List/BookListSelectedFilter";
import React from "react";
import styled, { useTheme } from "styled-components";
import { Close, Reset, Sizes } from "@/components/icon/IconList";
import Icon from "@/components/icon/Icon";
import { themeGet } from "@styled-system/theme-get";
import { Button } from "antd";
export const SelectedFilterWrapper = (param)=>{
    let { position , children , button , className  } = param;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: position === "sideSheet" ? "slider-type ".concat(className) : className,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "current-area",
                children: children
            }),
            button
        ]
    });
};
export const ResetButton = (param)=>{
    let { handleResetFilter  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(ResetButtonWrapper, {
        className: "reset-btn",
        onClick: handleResetFilter,
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: Reset,
                color: theme.new.colors.sol_gray_600,
                size: Sizes.small
            }),
            "초기화"
        ]
    });
};
export const SelectedItem = (param)=>{
    let { label , onRemove , className  } = param;
    return /*#__PURE__*/ _jsxs(SelectedItemWrapper, {
        onClick: onRemove,
        className: className || "current-btn",
        children: [
            label,
            /*#__PURE__*/ _jsx(Icon, {
                icon: Close,
                size: Sizes.small,
                color: "#fff"
            })
        ]
    });
};
SelectedFilterWrapper.ResetButton = ResetButton;
SelectedFilterWrapper.SelectedItem = SelectedItem;
export default SelectedFilterWrapper;
export const CategorySelectedItem = styled(SelectedItem).withConfig({
    componentId: "sc-212f1dc1-0"
})(_templateObject());
const ResetButtonWrapper = styled(Button).withConfig({
    componentId: "sc-212f1dc1-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_600, themeGet("text.0", "#1B1B29"), (props)=>props.theme.new.colors.sol_gray_500);
const SelectedItemWrapper = styled.div.withConfig({
    componentId: "sc-212f1dc1-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_500);
